import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  consentTitle: {
    paddingTop: '29px',
    paddingRight: '60px',
    textAlign: 'center',
    fontSize: '20px',
    fontFamily: 'Messina Sans Regular',
  },
  secondaryTitle: {
    paddingTop: '5px',
    textAlign: 'center',
    fontSize: '20px',
    fontFamily: 'Messina Sans Regular',
  },
  consentContent: {
    fontSize: '11px',
    display: 'block',
    height: 'auto',
    overflowY: 'hidden',
    backgroundColor: 'white',
    padding: '16px',
    textAlign: 'left',
    margin: '20px',
    '& h2': {
      fontSize: '16px',
    },
    '& h3': {
      fontSize: '14px',
    },
  },
  consentSignature: {
    display: 'block',
    height: '210px',
    width: '646px',
    backgroundColor: 'white',
    borderRadius: '4px',
    margin: '20px auto',
  },
  consentSignatureCanvas: {
    width: '646px',
    height: 'calc(100% - 40px)',
  },
  patientName: {
    display: 'flex',
    margin: '20px auto',
    width: '646px',
    backgroundColor: 'white',
    padding: '12px',
    marginBottom: '8px',
    fontFamily: 'Messina Sans Regular',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '0.88',
    letterSpacing: 'normal',
    borderRadius: '4px',
    border: 'solid 1px #979797',
    textTransform: 'capitalize',
  },
  signatureTitle: {
    color: 'rgba(0, 0, 0, 0.54)',
    position: 'relative',
    top: '15px',
    left: '20px',
    fontSize: '15px',
  },
  clearSignatureButton: {
    width: '193px',
    height: '47px',
    borderRadius: '3px',
    backgroundColor: '#ffffff',
    fontSize: '14px',
    margin: '15px 0',
  },
  doneSigningButton: {
    width: '193px',
    height: '47px',
    borderRadius: '3px',
    float: 'right',
    backgroundColor: '#12574d',
    color: '#ffffff',
    fontSize: '14px',
    margin: '15px 0',
  },
  closeIcon: {
    float: 'left',
    marginTop: '25px',
    marginLeft: '22px',
    width: '31px',
    height: '31px',
    cursor: 'pointer',
  },
  photoConsentAgreementModal: {
    zIndex: 3001,
  },
}));
